import "animate.css";

import { Box, Chip, Typography, useMediaQuery, useTheme } from "@mui/material";

function EmojiPicker({ pickedEmoji, setPickedEmoji }) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const emojis = [
		"🥩",
		"🥗",
		"🍗",
		"🐟",
		"🥘",
		"🍝",
		"🍔",
		"🍕",
		"🍞",
		"🥙",
		"🍣",
		"🥧",
	];

	//const [pickedEmoji, setPickedEmoji] = useState();

	function updatePickedEmoji(emoji) {
		pickedEmoji === emoji ? setPickedEmoji() : setPickedEmoji(emoji);
	}

	return (
		<Box paddingTop={3} textAlign="start">
			<Typography paddingTop={3} textAlign="start" variant="overline">
				Select an emoji
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					gap: isMobile ? 1 : 2,
					justifyContent: "center",
					flexWrap: "wrap",
					maxWidth: isMobile ? 350 : 400,
					//backgroundColor: green[200],
				}}
			>
				{emojis.map((emoji, i) => (
					<Chip
						key={i}
						onClick={() => updatePickedEmoji(emoji)}
						disabled={pickedEmoji ? pickedEmoji !== emoji : false}
						sx={{ backgroundColor: "#fff", fontSize: "2em" }}
						label={emoji}
					/>
				))}

				{/* <Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🥗" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🍗" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🐟" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🥘" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🍝" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🍔" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🍕" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🍞" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🥙" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🍣" />
				<Chip sx={{ backgroundColor: "#fff", fontSize: "2em" }} label="🥧" /> */}
			</Box>
		</Box>
	);
}
export default EmojiPicker;
